module.exports = __webpack_public_path__ + "fonts/Roboto-400-greek-ext3.bb723e8.woff2";